export default __webpack_public_path__ + "static/media/google_map.a8707dc2.png";